"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeModal = exports.showModal = exports.ConfirmationModalActions = exports.ActiveModal = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var ActiveModal;
(function (ActiveModal) {
    ActiveModal["None"] = "None";
    ActiveModal["Info"] = "Info";
    ActiveModal["Redirect"] = "Redirect";
    ActiveModal["Confirmation"] = "Confirmation";
})(ActiveModal || (exports.ActiveModal = ActiveModal = {}));
var ConfirmationModalActions;
(function (ConfirmationModalActions) {
    ConfirmationModalActions["DeleteMechanic"] = "DeleteMechanic";
    ConfirmationModalActions["DeleteCharacter"] = "DeleteCharacter";
    ConfirmationModalActions["DeleteLocation"] = "DeleteLocation";
    ConfirmationModalActions["DeleteGDD"] = "DeleteGDD";
    ConfirmationModalActions["DeleteAccount"] = "DeleteAccout";
})(ConfirmationModalActions || (exports.ConfirmationModalActions = ConfirmationModalActions = {}));
var initialState = {
    text: "",
    activeModal: ActiveModal.None,
    confirmAction: null,
};
var modalSlice = (0, toolkit_1.createSlice)({
    name: "modal",
    initialState: initialState,
    reducers: {
        showModal: function (state, action) {
            console.log(action);
            return action.payload;
        },
        closeModal: function (state) {
            state.activeModal = ActiveModal.None;
        },
    },
});
exports.showModal = (_a = modalSlice.actions, _a.showModal), exports.closeModal = _a.closeModal;
exports.default = modalSlice.reducer;
